import * as R from 'remeda';
import { IconAlertTriangle } from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon, Typography } from '@rossum/ui/material';

type ErrorMessagesProps = {
  errors: unknown;
};

const ErrorMessages = ({ errors }: ErrorMessagesProps) => {
  if (!R.isArray(errors) || errors.length === 0) {
    return null;
  }
  return (
    <Stack spacing={1}>
      {errors.map(error =>
        typeof error === 'string' ? (
          <Stack key={error} direction="row" spacing={2}>
            <SvgIcon color="error" fontSize="medium">
              <IconAlertTriangle />
            </SvgIcon>
            <Typography key={error} variant="body2" color="error">
              {error}
            </Typography>
          </Stack>
        ) : null
      )}
    </Stack>
  );
};

export { ErrorMessages };
